export const TOKEN_KEY = '@SAAW-SOEM-@WWL';

export const getItem = () => {};

export const setItem = () => {};

export const logoff = () => {};
